import { React } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faYoutube, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

function Footer() {
    return(
        <div className="footer-container">
            <div className="footer-content">
                <div className="footer-links">
                    <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                    <NavLink to="/EULA">EULA</NavLink>
                    <NavLink to="/BAA">BAA</NavLink>
                </div>
                <div className="footer-copyright">
                    <p>Copyright © 2025 enAble Games LLC | All Rights Reserved.</p>
                </div>
                <div className="footer-icons">
                    <div className="social-media-icon">
                        <a href="https://www.facebook.com/enablegames">
                            <FontAwesomeIcon icon={faFacebook} size="2x" />
                        </a>
                    </div>
                    <div className="social-media-icon">
                        <a href="https://x.com/enablegames">
                            <FontAwesomeIcon icon={faTwitter} size="2x" />
                        </a>
                    </div>
                    <div className="social-media-icon">
                        <a href="https://www.youtube.com/@enablegames9807/featured">
                            <FontAwesomeIcon icon={faYoutube} size="2x" />
                        </a>
                    </div>
                    <div className="social-media-icon">
                        <a href="https://www.linkedin.com/showcase/enablegames/">
                            <FontAwesomeIcon icon={faLinkedin} size="2x" />
                        </a>
                    </div>
                    <div className="social-media-icon">
                        <a href="https://www.instagram.com/enablegames/">
                            <FontAwesomeIcon icon={faInstagram} size="2x" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;